import { render } from "./stick-it-robert.vue?vue&type=template&id=1f7ea541&scoped=true"
import script from "./stick-it-robert.vue?vue&type=script&lang=js"
export * from "./stick-it-robert.vue?vue&type=script&lang=js"

import "./stick-it-robert.vue?vue&type=style&index=0&id=1f7ea541&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7ea541"]])

export default __exports__